import {
  CustomButton,
  CustomInputSelect,
  CustomTextInput,
} from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import { IDisableAutomaticRechargeFormMeta } from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/prepaidOperations/disableAutomaticRecharge/DisableAutomaticRechargeMeta';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { FaSave } from 'react-icons/fa';

type Props = {
  onSubmit: any,
  meta: IDisableAutomaticRechargeFormMeta,
  isLoading?: boolean,
  isSubmitting?: boolean,
};

const DisableAutomaticRechargeFormUI = ({ meta, onSubmit, isSubmitting, isLoading }: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    // reset,
  } = useForm({ resolver: yupResolver(meta.schema) });

  return (
    <CC.Box w={'100%'} as={'form'} onSubmit={handleSubmit(onSubmit)}>
      
      <CC.Box as="fieldset" 
       width={'100%'}>          
        <CC.SimpleGrid columns={{base: 1, sm:1, md: 2, lg:3}} spacing={10} my={10}>
          <CustomFormControl
            label={meta.idBank.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.idBank.name]}
          >
            <CustomTextInput
              meta={meta.idBank}
              register={register(meta.idBank.name)}
              hasError={errors[meta.idBank.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.nameBank.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.nameBank.name]}
          >
            <CustomTextInput
              meta={meta.nameBank}
              register={register(meta.nameBank.name)}
              hasError={errors[meta.nameBank.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.agency.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.agency.name]}
          >
            <CustomInputSelect
              meta={meta.agency}
              register={register(meta.agency.name)}
              hasError={errors[meta.agency.name]}
            />
          </CustomFormControl>

        </CC.SimpleGrid>
      </CC.Box>

      <CC.Divider my="5"/>

      <CC.Box as="fieldset" 
       width={'100%'}>          
        <CC.SimpleGrid columns={{base: 1, sm:1, md: 2, lg:3}} spacing={10} my={10}>
          
          <CustomFormControl
            label={meta.client.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.client.name]}
          >
            <CustomInputSelect
              meta={meta.client}
              register={register(meta.client.name)}
              hasError={errors[meta.client.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.account.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.account.name]}
          >
            <CustomInputSelect
              meta={meta.account}
              register={register(meta.account.name)}
              hasError={errors[meta.account.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.reason.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.reason.name]}
          >
            <CustomInputSelect
              meta={meta.reason}
              register={register(meta.reason.name)}
              hasError={errors[meta.reason.name]}
            />
          </CustomFormControl>
          
        </CC.SimpleGrid>
      </CC.Box>

      <CC.HStack my={6} justifyContent={'flex-end'}>
        <CustomButton isLoading={isSubmitting} type={'submit'}>
          <FaSave style={{ marginRight: '10px' }} /> Enregistrer
        </CustomButton>
      </CC.HStack>
    </CC.Box>
  );
};

export default DisableAutomaticRechargeFormUI;
